import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';


import reducers from './reducers/index';

const paymentMethods = [
    {
        id: 0,
        available: true,
        name: 'Cartão de Crédito',
        slug: 'credit-card',
        condition: 'sem juros',
        img: 'cartao_verde',
        class: 'cartao-credito',
        active: false,
        displayOrder: false,
        selected: false,
        discount: 0,
    },
    {
        id: 1,
        available: true,
        name: 'Boleto',
        slug: 'boleto',
        condition: '5% desconto',
        img: 'boleto',
        class: 'boleto',
        active: false,
        displayOrder: false,
        selected: false,
        discount: 0,
    },
    {
        id: 3,
        available: true,
        name: 'Transferência',
        slug: 'safetypay',
        condition: 'à vista',
        img: 'transferencia',
        class: 'transferencia',
        active: false,
        displayOrder: false,
        selected:  false,
        discount: 0,
    },
    {
        id: 2,
        available: true,
        name: 'Dinheiro',
        slug: 'cash',
        img: 'dinheiro',
        class: 'transferencia',
        active: false,
        displayOrder: false,
        selected: false,
        discount: 0,
    },
    {
        id: 4,
        available: true,
        deadline: 0,
        name: 'Pix',
        slug: 'pix',
        condition: 'sem juros',
        img: 'pix',
        class: 'pix',
        active: false,
        displayOrder: false,
        selected: false,
        discount: 0,
    },
];

const sortOptionsData = [
    {
        name: 'lower-price',
        displayName: 'Menor preço',
        mobile: true
    },
    {
        name: 'special',
        displayName: 'Custo benefício',
        mobile: true
    },
    {
        name: 'high-price',
        displayName: 'Maior preço',
        mobile: true
    },
    {
        name: 'covid_coverage',
        displayName: 'Cobertura covid',
        mobile: true
    },
]

const errorsDefault = {
    insuredForms: [{
        cpf: false,
        name: false,
        birth_date: false,
        incoming: false,
    }],
    paymentMethods: false,
    creditCard: {
        cvv: false,
        number: false,
        parcels: false,
        card_brand: false,
        expiry_year: false,
        holder_name: false,
        holder_cpf: false,
        expiry_month: false,
    },
    boleto: {
        name: false,
        cpf: false
    },
    safetypay: {
        cpf: false,
        name: false,
        banks: false,
        agency: false,
        account: false,
    },
    cash: {
        holderName: false,
        holderCpf: false,
    },
    pix: {
        cpf: false,
        name: false,
    },
    coupon: false,
    contact: {
        contact_name: false,
        email: false,
        phone_number: false
    },
    purchase_is_valid: false,
    errorsModalFranchise: false,
}

const search = {
    filterCategory: [],
    filterProvider: [],
    plans: [],
    loading: false,
    userDetails: {},
    filtered_plans: [],
    comparisonPlans: [],
    suggestions_plans: [],
    provider_option: '',
    great_for_selected: '',
    providers: [],
    sortOptions: sortOptionsData,
    sort_option: sortOptionsData[1].name,
    searchState: false,
    isModalQuotationDateWarningActive: false,
    prospect: {
        exist: false,
        name: '',
        email: '',
        phone: '',
    },
    isModalQuotationDateYearActive: false,
    isModalWithoutTrackerActive: false,
    isModalFilterCategoryActive: false,
    isModalUpsellActive: false,
    modalProspect: {
        name : '',
        email: '',
        phone: '',
        errors: {
            name: false,
            email: false,
            phone: false,
            isValid: false
        }
    },
    modalProspectAvaliable: false,
    ecommerce_settings: {
        filter: false,
        modalCovid: false,
        disabled_providers: []
    },
    showSpecialistSuggestions: false,
    highlightPlans: [],
    upsellPlans: [],
};

const comparison = {
    userDetails: {},
    loading: false,
    emailStatus: '',
    comparisonPlans: [],
    openedBenefitCode: '',
    comparisonPlansInfo: [],
    isModalEmailActive: false,
    emailModal: { emailAddress: '' },
    emailCollapse: { emailAddress: '' },
    isModalQuotationDateWarningActive: false,
    prospect: {
        exist: false,
        name: '',
        email: '',
        phone: '',
    },
    isModalQuotationDateYearActive: false,
};

const coverage = {
    userDetails: {},
    loading: false,
    productInfo: {},
    productCoverage: {},
    rawProductCoverage: {},
    isModalQuotationDateWarningActive: false,
    prospect: {
        exist: false,
        name: '',
        email: '',
        phone: '',
    },
    isModalQuotationDateYearActive: false,
};

const purchase = {
    loading: false,
    status: '',
    plan: {},
    coupon: {
        text: ''
    },
    creditCoupon: {
        code: null,
        creditAmount: 0.0,
        applied: false,
        error: null,
    },
    partner: '',
    paymentInfo: {},
    paymentMethods,
    payments: paymentMethods,
    insuredForms: [{
        id: 0,
        rg: '',
        cpf: '',
        name: '',
        birth_date: '',
        document_type: 'cpf',
        elder: false,
        incoming: '',
    }],
    quotationParams: {
        destination: '',
        return_date: '',
        product_code: '',
        departure_date: '',
        queryParams: '',
    },
    isInsuredFormDeletable: false,
    contact: {
        contact_name: '',
        email: '',
        phone_number: '',
        cep: '',
        city: '',
        state: '',
        number: '',
        address: '',
        district: '',
        complement: '',
    },
    creditCard: {
        cvv: '',
        number: '',
        brands: [],
        parcels: [],
        card_brand: {},
        expiry_year: '',
        available: true,
        holder_cpf: '',
        holder_name: '',
        expiry_month: '',
    },
    boleto: {
        cpf: '',
        name: '',
        available: false,
    },
    safetypay: {
        cpf: '',
        name: '',
        agency: '',
        account: '',
        banks: [],
        available: false,
    },
    cash: {
        available: false,
        holderName: '',
        holderCpf: '',
    },
    pix: {
        available: false,
        name: '',
        cpf: '',
    },
    acceptedTerms: false,
    dateTimeAccept: '',
    purchaseSummary: {
        total: 0,
        subtotal: 0,
        coupon_discount: 0,
        investmentPerDay: 0,
        adult: { qte: 1, price: 0 },
        child: { qte: 0, price: 0 },
        elder: { qte: 0, price: 0 },
        invalid: { qte: 0, price: 0 },
        paymentMethodDiscountValue: 0,
        paymentMethodDiscountPercent: 0,
        paymentMethodSelected: '',
        creditCouponAmountUsed: 0,
        creditCouponRemainingBalance: 0,
    },
    uuid: 0,
    alert: '',
    userDetails: {},
    benefits_list: [],
    errors: errorsDefault,
    purchaseIsValid: false,
    isModalNotCovidCoverage: false,
    isModalDetailActive: false,
    isModalFranchiseActive: false,
    isModalSafetypayActive: false,
    isModalTermsOfUseActive: false,
    isModalPurchaseErrorActive: false,
    isModalPurchaseErrorDate: false,
    isModalGenericErrorActive: false,
    isModalTravelRenewalActive: false,
    isModalRenewalFranchiseActive: false,
    isModalReceptiveProductActive: false,
    isInvalidCreditCardErrorVisible: false,
    isModalPlanRulesActive: false,
    isModalFailPayment: false,
    stagePurchase: 1,
    stepDisplayMethodPayment: 0,
    stepDisplayCreditCard: 0,
    stepDisplayCashTransfer: 0,
    stepDisplayBoleto: 0,
    stepDisplayPix: 0,
    stepPaymentFinish: false,
    invalidCreditCard: {
        brand: '',
        lastDigits: '',
    },
    prospect: {
        exist: false,
        name: '',
        email: '',
        phone: '',
    },
    upsellUpgrade: sessionStorage.getItem('upsellUpgrade'),
};

const purchaseStatus = {
    id: 0,
    price: 0,
    parcels: 0,
    loading: true,
    status: '',
    insureds: [],
    return_date: '',
    payment_method: '',
    departure_date: '',
}

const mobile = {
    mobileActive: window.innerWidth <= 768 ? true : false
}

const global = {
    loading: false,
    destinations: [],
    providers: [
        {
            id: 0,
            code: '',
            slug: '',
            name: '',
            logo: '',
            terms_url: '',
        },
    ],
}


const initialState = {
    search,
    comparison,
    coverage,
    purchase,
    purchaseStatus,
    mobile,
    global,
};

const middleware = [thunk]

const compose = enhancer => enhancer;

const composeEnhancers =
  process.env.NODE_ENV !== 'production' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          name: 'MyApp', actionsBlacklist: ['REDUX_STORAGE_SAVE']
      }) : compose;

const enhancer = composeEnhancers(
    applyMiddleware(...middleware),
);

// const enhancer = applyMiddleware(...middleware);


const store = createStore(
    reducers,
    initialState,
    enhancer
);

export default store;



// WEBPACK FOOTER //
// ./src/store.js